<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=Cormorant:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@200;300;400;500;600;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Italiana&family=Cinzel:wght@400;500;600;700&display=swap');

:root {
  /* Typography */
  --font-sans: 'Pretendard Variable', 'Pretendard', -apple-system, sans-serif;
  --font-serif-kr: 'Noto Serif KR', 'Nanum Myeongjo', serif;
  --font-serif-en: 'Cormorant Garamond', 'Cormorant', serif;
  --font-display: 'Italiana', 'Cinzel', 'Cormorant Garamond', serif;
  --font-mono-disp: 'Cinzel', 'Cormorant Garamond', serif;

  /* Le-el River Park Centum — Premium Palette (Warm Espresso Brown) */
  --le-noir: #1E140D;
  --le-ink: #271A11;
  --le-charcoal: #3A281B;
  --le-graphite: #574435;
  --le-warm-grey: #8B7A67;
  --le-pearl: #F5EFE2;
  --le-bone: #EBE1CE;
  --le-cream: #F7F1E6;
  --le-white: #FFFFFF;

  --le-champagne: #C9A96B;
  --le-champagne-light: #DEC18A;
  --le-champagne-dark: #A8884E;
  --le-gold-line: rgba(201, 169, 107, 0.32);
  --le-gold-line-soft: rgba(201, 169, 107, 0.16);

  /* Legacy mapping for existing components */
  --primary: var(--le-noir);
  --primary-light: var(--le-ink);
  --primary-dark: #140D07;
  --sub-color: var(--le-pearl);
  --text-color: #3A3A3A;
  --white: #ffffff;
  --font-family: var(--font-sans);
  --font-family2: var(--font-serif-en);
  --font-family4: var(--font-serif-kr);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--le-ink);
  background: var(--le-cream);
}

html, body {
  overflow-x: hidden;
  width: 100%;
  background: var(--le-cream);
}

img { display: block; max-width: 100%; }

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}
</style>
